module.exports = __webpack_public_path__ + "static/media/loader_new.c903da2b.gif";